meedy.controller('meedy.popupInvoiceNumberController', ['$scope', '$state', '$mdDialog', 'title', 'invoice', 'meedy.invoiceModel',
    function ($scope, $state, $mdDialog, title, invoice, invoiceModel) {

        function setData() {
            $scope.invoice = invoice;

            $scope.loading = false;

            $scope.forms = {
                invoice : null
            };
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$on(Event.MEEDY.INVOICE.UPDATE_INVOICE.SUCCESS, function(event, data) {
                $scope.loading = false;
                $mdDialog.hide();
            });

        }

        function setActions() {

            $scope.save = function () {
                $scope.forms.invoice.$setSubmitted();
                if($scope.forms.invoice.$valid) {

                    invoiceModel.updateInvoice($scope.invoice);
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

        }


        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        initialize();
    }
]);